import {
  Actor,
  Animation,
  CollisionType,
  SpriteSheet,
  vec,
  Vector,
} from "excalibur";
import { Resources } from "../../Resources";
import { Config } from "../../config";

export default class OldMan extends Actor {
  constructor(pos, sceneRef) {
    super({
      x: pos.x,
      y: pos.y,
      width: 32,
      height: 32,
      radius: 20,
      collisionType: CollisionType.Fixed,
      name: "ted",
    });
    this.started = false;
    this.sceneRef = sceneRef;
  }

  onInitialize() {
    const playerSpriteSheet = SpriteSheet.fromImageSource({
      image: Resources.OldManSpriteSheet,
      grid: {
        spriteWidth: 32,
        spriteHeight: 32,
        rows: 4,
        columns: 10,
      },
    });

    const leftIdle = new Animation({
      frames: [
        {
          graphic: playerSpriteSheet.getSprite(0, 0),
          duration: Config.PlayerFrameSpeed,
        },
      ],
    });
    const rightIdle = new Animation({
      frames: [
        {
          graphic: playerSpriteSheet.getSprite(0, 1),
          duration: Config.PlayerFrameSpeed,
        },
      ],
    });
    const sitAtBooth = new Animation({
      frames: [
        {
          graphic: playerSpriteSheet.getSprite(7, 2),
          duration: Config.PlayerFrameSpeed,
        },
      ],
    });
    const leftWalk = new Animation({
      frames: [
        {
          graphic: playerSpriteSheet.getSprite(0, 0),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(1, 0),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(2, 0),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(3, 0),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(4, 0),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(5, 0),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(6, 0),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(7, 0),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(8, 0),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(9, 0),
          duration: Config.PlayerFrameSpeed,
        },
      ],
    });
    const rightWalk = new Animation({
      frames: [
        {
          graphic: playerSpriteSheet.getSprite(0, 1),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(1, 1),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(2, 1),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(3, 1),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(4, 1),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(5, 1),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(6, 1),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(7, 1),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(8, 1),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(9, 1),
          duration: Config.PlayerFrameSpeed,
        },
      ],
    });

    this.graphics.add("leftIdle", leftIdle);
    this.graphics.add("rightIdle", rightIdle);

    this.graphics.add("leftWalk", leftWalk);
    this.graphics.add("rightWalk", rightWalk);
    this.graphics.add("sitAtBooth", sitAtBooth);
    const shadowSprite = playerSpriteSheet.getSprite(0, 2);
    const shadow = new Actor({ pos: new Vector(0, 0), z: 2 });
    if (this.sceneRef == "mccartys") {
      this.graphics.use("sitAtBooth");
    } else {
      shadow.graphics.add("shadow", shadowSprite);

      shadow.graphics.use("shadow");
    }

    this.addChild(shadow);
  }
  moveFunction(direction, amount) {
    console.log("cutscene: inside oldMan move");
    switch (direction) {
      case "left":
        this.graphics.use("leftWalk");
        this.vel = vec(-Config.GrandpaSpeed, 0);

        this.lastDir = "left";
        break;
      case "right":
        this.graphics.use("rightWalk");
        this.vel = vec(Config.GrandpaSpeed, 0);

        this.lastDir = "right";
        break;

      default:
        break;
    }
  }

  startAuto() {
    console.log("inside startAuto");
    this.actions.repeatForever((ctx) => {
      this.started = true;
      ctx
        .callMethod(() => {
          this.graphics.use("rightWalk");
        })
        .moveTo(53 * 16, 42 * 16, 10)
        .callMethod(() => {
          this.graphics.use("rightIdle");
        })

        .delay(5000)
        .callMethod(() => {
          this.graphics.use("leftWalk");
        })
        .moveTo(48 * 16, 42 * 16, 10)
        .callMethod(() => {
          this.graphics.use("leftIdle");
        })
        .delay(5000);
    });
  }
  startFurdlandAuto() {
    this.actions.repeatForever((ctx) => {
      this.started = true;
      ctx
        .callMethod(() => {
          this.graphics.use("rightWalk");
        })
        .moveTo(20 * 16, 9 * 16, 7)
        .callMethod(() => {
          this.graphics.use("rightIdle");
        })

        .delay(5000)
        .callMethod(() => {
          this.graphics.use("leftWalk");
        })
        .moveTo(17 * 16, 9 * 16, 7)
        .callMethod(() => {
          this.graphics.use("leftIdle");
        })
        .delay(5000);
    });
  }
  onPostUpdate(engine) {
    if (!this.started && this.sceneRef == "town") {
      this.startAuto();
    } else if (!this.started && this.sceneRef == "furdland") {
      this.startFurdlandAuto();
    }
    if (this.interacting) {
      if (engine.input.keyboard.wasPressed(Keys.Enter)) {
        this.greetingDialog.enterPress();
      }
    }
  }
}
